import Vue from 'vue'
import Vuex from 'vuex'
// import $axios from 'axios';
import {i18n} from '../i18n';
// import AES from "@/tools/AES.js";
import router from '@/router';
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        localeLang: localStorage.getItem('localeLang')||'en',
        token:localStorage.getItem('token'),
        userInfo:JSON.parse(localStorage.getItem('userInfo')||null),
        countryArr:null,
        isShowSelArea:true,
    },
    mutations: {
        // 设置语言
        setLanguage(state,selLang){
            let thislang;
            if(selLang){
                // 如果指定了语言，使用指定语言
                thislang=selLang;
                localStorage.setItem('localeLang',thislang);
            }else if(localStorage.getItem('localeLang')){
                // 无指定语言，取缓存值
                thislang=localStorage.getItem('localeLang');
            }else{
                // 否则 获取浏览器语言
                let language = navigator.language || navigator.browserLanguage;
                let langDa = language.toUpperCase();
                thislang = language.substr(0, 2);
                if (langDa == 'ZH-MO' || langDa == 'ZH-TW' || langDa == 'ZH-HK' || langDa == 'ZH-RHK' || langDa == 'ZH-HANT-TW' || langDa == 'ZH-HANT-HK' || langDa.indexOf("ZH-HANT") != -1) {
                    language = 'zh-rHK';
                    thislang = 'zh-rHK';
                }
            }

            if(thislang!=='ar'&&thislang!=='de'&&thislang!=='en'&&thislang!=='es'
            &&thislang!=='fr'&&thislang!=='hi'&&thislang!=='id'&&thislang!=='it'
            &&thislang!=='ja'&&thislang!=='ko'&&thislang!=='pt'&&thislang!=='ru'&&
            thislang!=='th'&&thislang!=='tr'&&thislang!=='vi'&&thislang!=='zh-rHK'&&thislang!=='zh'){
                thislang='en'
            }
            // 上一个语言
            let oldThisLang=state.localeLang;
            // 设置当前语言
            state.localeLang = thislang;
            i18n.locale=thislang;
            document.title=i18n.t('m.guild_system_title');
            /*
                body节点增加当前语言class，移除上个语言class
                便于后期不同语言做适配使用
            */
           console.log(thislang,oldThisLang);
            var box = document.body;
            // 遵循先移除在添加的原则
            box.classList.remove(oldThisLang)
            box.classList.add(thislang)
            if(thislang=='ar'){
                box.style.direction = 'rtl';
            }else{
                box.style.direction = 'initial';
            }
        },
        setUser: (state, userInfo) => {
            // console.log(userInfo);
            state.userInfo = userInfo;
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
            localStorage.setItem('token', userInfo.token)
            if(userInfo.areaCode){
                localStorage.setItem('areaCode', userInfo.areaCode)
            }

            state.userInfo.token = userInfo.token
        },
        loginOut:(state) => {
            // console.log(state);
            localStorage.removeItem('userInfo')
            localStorage.removeItem('token')

            router.push({
                path: '/login',
            })
        },
        getGuildName: (state,{guildName,guildLogo, userName}) => {
            console.log(guildName,guildLogo);
            if(guildName){
                state.userInfo.guildName = guildName;
                console.log(state.userInfo)
            }
            if(guildLogo){
                state.userInfo.guildLogo = guildLogo;
            }
            if(userName){
                state.userInfo.userName = userName;
            }
            localStorage.setItem('userInfo', JSON.stringify(state.userInfo));
        },
    },

    actions: {

    },

    modules: {}
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js